// extracted by mini-css-extract-plugin
module.exports = {"totalEntries":"TotalCount_totalEntries__2K6Kg","label":"TotalCount_label__1GGr3","result":"TotalCount_result__2Pusk"};